interface IGetOnboardingTimelineParams {
  slideMs: number;
  holdMs: number;
  fadeMs: number;
}

/**
 * Границы фаз одной итерации онбординга в долях 0…1 от её полной длительности.
 * Фазы идут строго по порядку: сдвиг → появление хинта → удержание → скрытие
 * хинта → возврат. Каждая граница — момент окончания предыдущей фазы.
 */
interface IOnboardingTimeline {
  /** Полная длительность итерации (мс) */
  total: number;
  /** Сообщение доехало до отведённого положения */
  slideEnd: number;
  /** Хинт полностью проявился */
  hintVisible: number;
  /** Удержание хинта закончилось, начинается его скрытие */
  hintHoldEnd: number;
  /** Хинт скрылся, сообщение начинает возвращаться */
  slideBackStart: number;
}

export const getOnboardingTimeline = ({
  slideMs,
  holdMs,
  fadeMs,
}: IGetOnboardingTimelineParams): IOnboardingTimeline => {
  // Итерация — пять фаз подряд: сдвиг туда (slideMs), проявление хинта (fadeMs),
  // удержание (holdMs), скрытие хинта (fadeMs), возврат обратно (slideMs)
  const totalMs = slideMs * 2 + fadeMs * 2 + holdMs;
  // Переводит длительность фазы (мс) в долю от полной итерации — формат offset в WAAPI
  const toFraction = (durationMs: number) => durationMs / totalMs;

  return {
    total: totalMs,
    slideEnd: toFraction(slideMs),
    hintVisible: toFraction(slideMs + fadeMs),
    hintHoldEnd: toFraction(slideMs + fadeMs + holdMs),
    slideBackStart: toFraction(slideMs + fadeMs + holdMs + fadeMs),
  };
};
